import ITTObjectModelBase from '../_generated/modelBases/itt-object-model-base';

export default class ITTObjectModel extends ITTObjectModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
